export class TableLimiter {
  tableWrappers: NodeListOf<HTMLElement>;
  limit: number = 9;

  constructor() {
    this.tableWrappers = document.querySelectorAll('[data-table-toggle]');
    this.init();
  }

  init() {
    this.tableWrappers.forEach(tableWrapper => {
      let table = tableWrapper.querySelector('table');
      let rowsLength = table.rows.length;

      if (rowsLength > this.limit) {
        let rows = table.getElementsByTagName('tr');
        let toggleTrigger = document.createElement('a');

        for (let i= this.limit; i < rowsLength; i++) {
          rows[i].dataset.tableToggleRow = '';
        }

        this.toggleRows(table);

        toggleTrigger.classList.add('c-table__trigger', 'c-table__trigger--collapsed');
        toggleTrigger.href = '#';
        toggleTrigger.innerText = tableWrapper.dataset.tableToggle;
        toggleTrigger.dataset.tableToggleTrigger = '';

        tableWrapper.appendChild(toggleTrigger);
      }
    })
    this.addEventListeners();
  }

  toggleRows(table) {
    let rows = table.querySelectorAll('[data-table-toggle-row]');
    rows.forEach(row => {
      row.classList.toggle('d-none');
    })
  }

  addEventListeners() {
    this.tableWrappers.forEach(tableWrapper => {
      let toggleTrigger : HTMLAnchorElement = tableWrapper.querySelector('[data-table-toggle-trigger]');
      let labelMore: string = tableWrapper.dataset.tableToggle;
      let labelLess: string = tableWrapper.dataset.tableToggleLess;

      if (toggleTrigger) {
        let table = tableWrapper.querySelector('table');
        toggleTrigger.addEventListener('click', (e) => {
          e.preventDefault();
          toggleTrigger.classList.toggle('c-table__trigger--collapsed');
          toggleTrigger.innerText = toggleTrigger.classList.contains('c-table__trigger--collapsed') ? labelMore : labelLess;
          this.toggleRows(table);
        })
      }
    })
  }
}

document.addEventListener("DOMContentLoaded", function() {
  new TableLimiter();
});
